import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatState} from 'api/types'

export const masterKeyDeleted: CaseReducer<NinchatState> = (state) => state
